export class PaymentListTotalsModel {
  fromObject(object: any): PaymentListTotalsModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public totalAmount: number;
  public amountLeft: number;
}
